import Footer from "./Footer";
import Header from "./Header";
import "./Termsandconditions.css";
import { useState } from "react";
import SEO from "./SeoHelmet";
import metaConfig from "./SeoComponent";
import { useLocation } from "react-router-dom";

function Termsandconditions() {
  const location = useLocation(); // Get the current location (path)
  const meta = metaConfig.terms;

  const [submenuOpen, setSubmenuOpen] = useState(false);

  return (
    <div>
      <SEO {...meta} />

      {/* <!-- Navbar & Hero Start --> */}
      <div class="container-fluid position-relative p-0">
        <div class="w-100 me-3 top_head">
          <div class="top_head align-items-center"></div>
        </div>
        <Header />
      </div>
      {/* <!-- Navbar & Hero End -->
    <!-- Header Start --> */}
      <div class="container-fluid Terms bg-breadcrumb">
        <div class="container text-center py-5" style={{ maxWidth: "900px" }}>
          <ol
            class="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown"
            data-wow-delay="0.3s"
          ></ol>
          <h4
            class="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            Clear, Simple, Transparent!
          </h4>
        </div>
      </div>
      {/* <!-- Header End -->

    <!-- Modal Search Start --> */}
      <div
        class="modal fade"
        id="searchModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-fullscreen">
          <div class="modal-content rounded-0">
            <div class="col-lg-12 m-auto modal-header justify-content-lg-end">
              <button
                type="button"
                class="btn-close justify-content-lg-end text-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="col-lg-9 m-auto modal-header align-items-center text-center">
              <h4
                class="modal-title mb-0 m-auto text-white"
                id="exampleModalLabel"
              >
                Search by keyword
              </h4>
            </div>
            <div class="modal-body align-items-center">
              <div class="input-group w-75 mx-auto d-flex">
                <input
                  type="search"
                  class="form-control p-3"
                  placeholder="keywords"
                  aria-describedby="search-icon-1"
                />
                <span
                  id="search-icon-1"
                  class="input-group-text btn border p-3"
                >
                  <i class="fa fa-search text-white"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Modal Search End --> */}

      {/* <!-- About Start --> */}
      <div class="container-fluid about overflow-hidden py-5">
        <div class="container">
          <div class="row g-5">
            <div
              class="col-xl-9 pb-5 m-auto wow fadeInRight"
              data-wow-delay="0.2s"
            >
              <div class="about-item text-center"></div>
              <div class="row mt-5 goals_rules g-4 justify-content-center"></div>

              <div className="about-item text-center d-flex flex-column justify-content-center align-items-center">
                <h1
                  className="display-3 text-white"
                  style={{ fontFamily: "Poppins" }}
                >
                  Terms and Conditions
                </h1>
                <p
                  className="text-white"
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "14px",
                    lineHeight: "1.5",
                    wordWrap: "break-word",
                    maxWidth: "100%",
                    padding: "0 15px",
                  }}
                >
                  KTIG upholds rigorous professional standards across all our
                  engagements. Our services are governed by detailed agreements
                  that protect data privacy, safeguard intellectual property,
                  and ensure quality. We operate with clearly defined service
                  level agreements, ensuring the confidentiality of client data.
                  All activities comply with Indian laws and regulations, with
                  well-established procedures for resolving disputes. For
                  specific terms and conditions for each service, please reach
                  out to our legal team.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      <a
        href="#"
        class="btn btn-secondary btn-lg-square rounded-circle back-to-top"
      >
        <i class="fa fa-arrow-up"></i>
      </a>
    </div>
  );
}

export default Termsandconditions;
